import { useParams } from 'react-router-dom';

import { Button, ButtonGroup, Typography } from 'shared';

import { useJournalFilterContext } from 'features/journal/context';
import { useJournalMarkNotesAsReadMutation } from 'features/journal/hooks/mutation/useMarkNotesAsRead';
import { useParticipantQuery } from 'features/participants/hooks';

export const JournalFilterHeader = () => {
  const { email } = useParams();
  const { participant } = useParticipantQuery(email);

  const { resetQueryParams } = useJournalFilterContext();

  const { mutateAsync: markNotesAsRead } = useJournalMarkNotesAsReadMutation({
    participantId: participant.userId,
  });

  const handleMarkNotesAsRead = async () => await markNotesAsRead();

  return (
    <ButtonGroup width="100%" size="lg" variant="ghost" justifyContent="center">
      <Button
        onClick={handleMarkNotesAsRead}
        data-testid="journal-sidebar-filters-read-all-button"
      >
        <Typography color="blue">Read all</Typography>
      </Button>
      <Button
        onClick={resetQueryParams}
        data-testid="journal-sidebar-filters-reset-filters-button"
      >
        <Typography color="blue">Reset filters</Typography>
      </Button>
    </ButtonGroup>
  );
};
